import React, { FC } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Header } from "../Header";
import { ButtonIconPlaceholder } from "../buttonIconPlaceholder/ButtonIconPlaceholder";

interface PanelHeaderProps {
  readonly onBack: (() => void) | undefined;
}

const PanelHeader: FC<PanelHeaderProps> = ({ onBack }) => {
  const orderReturnTitleText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.ORDER_RETURN_TITLE,
  });

  return (
    <Header testID="panel-header">
      <ButtonIcon name="arrow_left" testID="arrow-left-button-icon" onPress={onBack} />
      <Text ellipsizeMode="tail" level={3} numberOfLines={1} style={{ flexShrink: 1 }} variant="action">
        {orderReturnTitleText}
      </Text>
      <ButtonIconPlaceholder />
    </Header>
  );
};
export { PanelHeader };
